<!-- <div (click)="okdh()">click</div>
<table *ngIf="this._fb.previewData.length>0" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
       class="mat-elevation-z8">

  <ng-container [matColumnDef]="item" *ngFor="let item of _tableKeys;">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="'Sort by {{item}}">
      {{item}}
    </th>
    <td mat-cell *matCellDef="let element"> {{element[item]}} </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="_tableKeys"></tr>
  <tr mat-row *matRowDef="let row; columns: _tableKeys;"></tr>
</table> -->



<div *ngIf="_fb.showPreviewSection">
  <div class="preview-wrapper" *ngIf="_fb.previewData.length>0">
    <div class="d-flex justify-content-between pt-4">
      <app-linear-loader *ngIf="_fb.tableLoading"></app-linear-loader>
      <div class="d-flex align-items-center">
        <div><img src="../../../../../assets/images/svg/excel-icon.svg" alt=""></div>
        <div class="scad-table-hash">Preview Dataset > Table</div>
      </div>

      <div class="d-flex align-items-center">

        <div class="scad-table-hash pe-4">Loaded in 387 ms</div>

        <div class="d-flex align-items-center pe-4">
          <div class="pe-2"><img src="../../../../../assets/images/svg/table-icon1.svg" alt=""></div>
          <div class="scad-test-flow__buttons">
            <button class="scad-drop-btn" [matMenuTriggerFor]="menu">
              <span> 40 </span>
              <span class="arrow" ><img src="/assets/images/svg/arrow-down.svg" width="15px" alt=""/></span>
            </button>
            <mat-menu #menu="matMenu" class="scad-table__table-dropdown">
              <div class="scad-title__sm-label-sub2 pb-2">Load All (12000 rows)</div>
              <div class="scad-title__sm-thin-gray2 pb-2">First 30</div>
              <div class="scad-title__sm-thin-gray2 pb-2">First 500   </div>
              <div class="scad-title__sm-thin-gray2 pb-2">Random 30
              </div>
              <div class="scad-title__sm-thin-gray2 pb-2">Random 500
              </div>
            </mat-menu>
          </div>
        </div>

        <div class="d-flex align-items-center pe-5">
          <div class="pe-2"><img src="../../../../../assets/images/svg/table-icon2.svg" alt=""></div>
          <div class="scad-test-flow__buttons">
            <button class="scad-drop-btn" [matMenuTriggerFor]="menu2">
              <span> 10 </span>
              <span class="arrow" ><img src="/assets/images/svg/arrow-down.svg" width="15px" alt=""/></span>
            </button>
            <mat-menu #menu2="matMenu" class="scad-table__table-dropdown">
              <div class="scad-checkbox scad-checkbox__small-check pb-2" >
                <input type="checkbox" name="all" id="">
                <label class="scad-title__sm-label-sub" for="selectitem">Select All (12 columns) </label>
              </div>
              <div class="ps-4">
                <div class="scad-checkbox scad-checkbox__small-check" >
                  <input   type="checkbox" name="" id="">
                  <label class="scad-title__sm-label-sub" for="aa"> Column 1 </label>
                </div>

                <div class="scad-checkbox scad-checkbox__small-check" >
                  <input   type="checkbox" name="" id="">
                  <label class="scad-title__sm-label-sub" for="dd"> Column 2</label>
                </div>

                <div class="scad-checkbox scad-checkbox__small-check" >
                  <input   type="checkbox" name="" id="">
                  <label class="scad-title__sm-label-sub" for="33"> Column 3 </label>
                </div>
              </div>
            </mat-menu>
          </div>
        </div>

        <div class="pe-4"><img src="../../../../../assets/images/svg/table-icon3.svg" alt=""></div>
        <div class="pe-4"><img src="../../../../../assets/images/svg/table-icon4.svg" alt=""></div>
        <div class="pe-4"><img src="../../../../../assets/images/svg/table-icon5.svg" alt=""></div>



      </div>

    </div>

    <div class="table-wrapper">
      <table>
        <tbody>
          <tr>
            <th *ngFor="let item of _tableKeys;">{{item}}</th>
          </tr>
          <tr *ngFor="let item of _tableData[page-1];let i=index">
            <td *ngFor="let key of _tableKeys;">{{item[key]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination">
      <div class="row-count">
        <p>Row per page</p>
        <ng-select [items]="pageArr" [searchable]="false" [clearable]="false" [(ngModel)]="selectedPage" (change)="page=1"></ng-select>
        <p>{{'of '+_fb.previewData.length+' rows'}}</p>
      </div>
      <div class="row-pagination">
        <svg (click)="decriement()" class="left" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
          viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="16" transform="matrix(-1 0 0 1 32 0)" fill="#1847DF" />
          <path d="M13 12.5L18 16.45L13 20.3571" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <div class="number">{{page}}</div>
        <p>{{'out of '+_tableData.length}}</p>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"
          (click)="incriement()">
          <circle cx="16" cy="16" r="16" transform="matrix(-1 0 0 1 32 0)" fill="#1847DF" />
          <path d="M13 12.5L18 16.45L13 20.3571" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  </div>
  <div class="no-data" *ngIf="_fb.previewData.length===0">
    Select Node For Preview
  </div>

</div>

<div *ngIf="!_fb.showPreviewSection">
  <div [ngSwitch]="_fb.visualizeType">
    <div *ngSwitchCase="'Table'">
      Table
    </div>

    <div *ngIf="_fb.isPublishToIfp === true">
      <div *ngSwitchCase="'KPI Card'">
        <div class="scad-preview mt-4" [ngClass]="{'expand': showGraphToggle}">

          <div class="scad-card px-4 py-4">

            <div class="d-flex justify-content-between w-100">
              <div class="d-flex align-items-center">
                <img class="pe-3" src="../../../../../assets/images/svg/growth.svg" width="43px" alt="">
              </div>

              <div class="d-flex align-items-center">
                <img class="pe-3" src="../../../../../assets/images/svg/notif.svg" width="35px" alt="">

                <div class="d-flex  pe-3" >
                  <div class="box-small  me-1" (click)="showGraph()" [ngClass]="{'active' : !showGraphToggle}" ></div>
                  <div class="box-large" (click)="showGraph()" [ngClass]="{'active' : showGraphToggle}"></div>
                </div>
                <img src="../../../../../assets/images/svg/link-to.svg" width="18px" alt="">

              </div>
            </div>

            <div class="d-flex pb-4">
              <div class="scad-card__left-side">

                <div class="pt-3">
                  <div class="scad-content-black__bold">{{_fb.visualizeTitle}}
                  </div>
                </div>

                <div >
                  <div>
                    <div class="pt-2 " *ngIf="_fb.visualizeComparison === 'greater'">

                      <div class="d-flex scad-card__count-status pt-2">
                        <div class="scad-card__count-status-bold d-flex">
                          <span><svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.5 0L6.53109 5.25H0.468911L3.5 0Z" fill="#008835"/>
                          </svg>
                          </span>
                          {{_fb.visualizeCharge}}
                          </div>
                          <div  class="ps-2">(1.8%)</div>
                      </div>

                      <div class="scad-title__has-sub-2 pt-2">Comparing to Monthly <span><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.00036 0.662551L5.97042 5.63261L10.6328 0.970215" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10"/>
                        </svg>
                        </span>
                      </div>

                      <div class="scad-title__semi-bold2 pt-3">
                        {{_fb.visualizeDescription}}
                        <!-- What makes education inflation worse are the innumerable hidden charges. -->
                      </div>

                      <div class="d-flex align-items-center  pt-2">
                        <div> <img src="assets//images/svg/calendar-outline.svg " width="13px" alt=""> </div>
                        <div class="ps-2 scad-title__hash-sub">Updated: 12/12/2022</div>
                      </div>


                      <!-- <div class="pe-1 scad-content-green">Upto</div> -->
                      <!-- <div class="pe-1 scad-content-green__bold"></div>
                      <div class="pe-2 scad-content-green">
                        <div>AED</div>
                        <div>Hidden charges</div>
                      </div> -->
                    </div>
                    <div  class="pt-2 " *ngIf="_fb.visualizeComparison === 'equal'">

                      <div class="d-flex scad-card__count-status pt-2">
                        <div class="scad-card__count-status-bold d-flex">
                          <span><svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.5 0L6.53109 5.25H0.468911L3.5 0Z" fill="#008835"/>
                          </svg>
                          </span>
                          {{_fb.visualizeCharge}}
                          </div>
                          <div  class="ps-2">(1.8%)</div>
                      </div>

                      <div class="scad-title__has-sub-2 pt-2">Comparing to Monthly <span><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.00036 0.662551L5.97042 5.63261L10.6328 0.970215" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10"/>
                        </svg>
                        </span>
                      </div>

                      <div class="scad-title__semi-bold2 pt-3">
                        {{_fb.visualizeDescription}}
                        <!-- What makes education inflation worse are the innumerable hidden charges. -->
                      </div>

                      <div class="d-flex align-items-center  pt-2">
                        <div> <img src="assets//images/svg/calendar-outline.svg " width="13px" alt=""> </div>
                        <div class="ps-2 scad-title__hash-sub">Updated: 12/12/2022</div>
                      </div>


                      <!-- <div class="pe-1 scad-content-orange">Upto</div>
                      <div class="pe-1 scad-content-orange__bold">{{_fb.visualizeCharge}}</div>
                      <div class="pe-2 scad-content-orange">
                        <div>AED</div>
                        <div>Hidden charges</div>
                      </div> -->


                    </div>

                    <div class="pt-2 " *ngIf="_fb.visualizeComparison === ''">

                      <div class="d-flex scad-card__count-status pt-2">
                        <div class="scad-card__count-status-bold d-flex">
                          <span><svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.5 0L6.53109 5.25H0.468911L3.5 0Z" fill="#008835"/>
                          </svg>
                          </span>
                          0.9
                          </div>
                          <div  class="ps-2">(1.8%)</div>
                      </div>

                      <div class="scad-title__has-sub-2 pt-2">Comparing to Monthly <span><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.00036 0.662551L5.97042 5.63261L10.6328 0.970215" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10"/>
                        </svg>
                        </span>
                      </div>

                      <div class="scad-title__semi-bold2 pt-3">
                        {{_fb.visualizeDescription}}
                        <!-- What makes education inflation worse are the innumerable hidden charges. -->
                      </div>

                      <div class="d-flex align-items-center  pt-2">
                        <div> <img src="assets//images/svg/calendar-outline.svg " width="13px" alt=""> </div>
                        <div class="ps-2 scad-title__hash-sub">Updated: 12/12/2022</div>
                      </div>

                    </div>

                    <div class="pt-2 " *ngIf="_fb.visualizeComparison === 'lesser'">


                      <div class="d-flex scad-card__count-status pt-2">
                        <div class="scad-card__count-status-bold d-flex">
                          <span><svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.5 0L6.53109 5.25H0.468911L3.5 0Z" fill="#008835"/>
                          </svg>
                          </span>
                          {{_fb.visualizeCharge}}
                          </div>
                          <div  class="ps-2">(1.8%)</div>
                      </div>

                      <div class="scad-title__has-sub-2 pt-2">Comparing to Monthly <span><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.00036 0.662551L5.97042 5.63261L10.6328 0.970215" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10"/>
                        </svg>
                        </span>
                      </div>

                      <div class="scad-title__semi-bold2 pt-3">
                        {{_fb.visualizeDescription}}
                        <!-- What makes education inflation worse are the innumerable hidden charges. -->
                      </div>

                      <div class="d-flex align-items-center  pt-2">
                        <div> <img src="assets//images/svg/calendar-outline.svg " width="13px" alt=""> </div>
                        <div class="ps-2 scad-title__hash-sub">Updated: 12/12/2022</div>
                      </div>


                      <!-- <div class="pe-1 scad-content-red">Upto</div>
                      <div class="pe-1 scad-content-red__bold">{{_fb.visualizeCharge}}</div>
                      <div class="pe-2 scad-content-red">
                        <div>AED</div>
                        <div class="">Hidden charges</div>
                      </div> -->
                    </div>

                  </div>

                  <!-- <div class="pt-2 text-educa">{{_fb.visualizeDescription}}</div> -->

                  <div>
                  </div>
                </div>
              </div>

              <div class="scad-card__right-side pb-3">
                <div class="pt-3" *ngIf="showGraphToggle">
                  <!-- <div>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus sapiente saepe at quae pariatur. Ullam aliquid itaque voluptate aliquam voluptatum sunt nulla magnam corrupti quas, accusantium impedit neque reiciendis recusandae!
                  </div> -->
                  <div *ngIf="graphLineData?.line_chart && graphLineData?.line_chart?.length > 0">
                    <app-line-chart [data]="getLineData()" [labels]="getLineLabels()" [colors]="graph_color"></app-line-chart>
                  </div>
                </div>
              </div>
            </div>

          <div class="scad-card__bottom">
            <div> <img src="../../../../../assets/images/svg/close-round.svg" alt=""> </div>
            <div> <img src="../../../../../assets/images/svg/download.svg" alt=""> </div>
          </div>


          </div>
        </div>
      </div>

    </div>

    <div *ngSwitchCase="'Geo-Chart'">Geo-Chart</div>
    <div *ngSwitchCase="'Chart'">Chart</div>
  </div>

</div>
